/*! @azure/msal-node v2.6.6 2024-03-27 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-node";
const version = "2.6.6";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
